import {
  FormControl,
  FormHelperText,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './MUISelect.styles';

const MUISelect = ({
  id,
  name,
  disabled,
  label,
  value,
  onChange,
  options,
  classes,
  placeholder,
  required,
  loading,
  inputDataTestId,
  errors,
}) => {
  const getOptions = () => {
    if (loading || !options.length) return null;
    const mappedOptions = options.map(option => (
      <MenuItem key={option?.id || option.label} value={option?.id || ''}>
        {option.label}
      </MenuItem>
    ));
    if (placeholder) {
      return [
        <MenuItem key="placeholder" disabled value="">
          {placeholder}
        </MenuItem>,
      ].concat(mappedOptions);
    }
    return mappedOptions;
  };

  return (
    <FormControl classes={{ root: classes.root }} required={required} error={errors[name]}>
      {label ? (
        <InputLabel
          htmlFor={name}
          error={errors[name]}
          required={required}
          classes={{ root: classes.label, shrink: classes.label }}
          disableAnimation
          shrink
          disabled={disabled || loading}
        >
          {label}
        </InputLabel>
      ) : null}
      <Select
        id={id}
        fullWidth
        name={name}
        disabled={disabled || loading}
        inputProps={{ name, required, 'data-testid': inputDataTestId }}
        value={value}
        onChange={onChange}
        classes={{ select: classes.selectInput }}
        displayEmpty
        error={errors[name]}
      >
        {getOptions()}
      </Select>
      {loading ? (
        <LinearProgress data-testid="loading-options" className={classes.progress} />
      ) : null}
      <FormHelperText error={errors[name]}>{errors[name]?.error}</FormHelperText>
    </FormControl>
  );
};

MUISelect.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, label: PropTypes.string.isRequired }),
  ).isRequired,
  required: PropTypes.bool,
  loading: PropTypes.bool,
  errors: PropTypes.shape({
    error: PropTypes.string,
  }),
  inputDataTestId: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
};

MUISelect.defaultProps = {
  disabled: false,
  placeholder: undefined,
  label: undefined,
  required: false,
  loading: false,
  inputDataTestId: undefined,
  errors: {},
};

export default withStyles(styles)(MUISelect);
